export default class MathUtils {
  public static roundToTwo = (num: number) => {
    const m = Number((Math.abs(num) * 100).toPrecision(15));
    return (Math.round(m) / 100) * Math.sign(num);
  };
}
